export const CHECK_AND_STORE_POLL = "polls/CHECK_AND_STORE_POLL"
export const OPEN_ACTIVE_POLL_MODAL_START = "polls/OPEN_ACTIVE_POLL_MODAL_START"
export const OPEN_ACTIVE_POLL_MODAL_COMPLETED = "polls/OPEN_ACTIVE_POLL_MODAL_COMPLETED"
export const SET_POLL_MODAL_TYPE = "polls/SET_POLL_MODAL_TYPE"
export const CLOSE_POLL_MODAL = "polls/CLOSE_POLL_MODAL"
export const SET_IS_FETCHING_SUBMIT_VOTE = "polls/SET_IS_FETCHING_SUBMIT_VOTE"
export const SUBMIT_VOTE_COMPLETED = "polls/SUBMIT_VOTE_COMPLETED"
export const VIEW_POLL_COMPLETED = "polls/VIEW_POLL_COMPLETED"
export const OPEN_CLOSE_POLL_CONFIRM_DIALOG = "polls/OPEN_CLOSE_POLL_CONFIRM_DIALOG"
